<h1 class="mat-dialog-title mt-3">Reminder to</h1>

<mat-card class="mat1">
  <div class="mt-4">
    <form [formGroup]="mail">
      <div class="col-md-12">
        <mat-form-field>
          <mat-label>To</mat-label>
          <input matInput type="email" formControlName="to" />
        </mat-form-field>
      </div>

      <div class="row">
        <div class="col-md-12">
          <mat-label>CC</mat-label>

          <dg-employee-search
            #empSearch
            [empConfig]="empConfig"
            [orgConfig]="orgConfig"
            (output)="getData2($event)"
          >
          </dg-employee-search>
        </div>
      </div>

      <div class="col-md-12">
        <mat-form-field>
          <mat-label>Subject</mat-label>
          <input matInput type="text" formControlName="subject" />
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field>
          <mat-label>Content</mat-label>
          <!-- <input
            md-textarea
            matInput
            type="textarea"
            formControlName="subject"
          /> -->
          <textarea
            matInput
            appearance="fill"
            formControlName="content"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="col-md-12 text-end mt-3">
        <button
          class="me-2"
          mat-raised-button
          color="secondary"
          mat-flat-button
          mat-dialog-close
        >
          Close
        </button>
        <button class="me-2" mat-raised-button color="primary" (click)="Send()">
          Send
        </button>
      </div>
    </form>
  </div>
</mat-card>
<!-- [disabled]="mail.invalid" -->
<!-- [selectedEmployeeList]="selectedEmployeeList" -->
